import { componentQrl, inlinedQrl, _jsxBranch, _jsxC, Slot, useSignal, useContextProvider, _IMMUTABLE, _fnSignal, useContext, useTaskQrl, useLexicalScope, _qrlSync, _jsxS } from "@builder.io/qwik";
import { CheckboxContext, CheckListContext } from "./context-id.qwik.mjs";
import { getTriBool } from "../checklist/checklist-context-wrapper.qwik.mjs";
const CheckboxRoot = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  _jsxBranch();
  if (props.checklist)
    return /* @__PURE__ */ _jsxC(MixedStateCheckbox, {
      ...props,
      children: /* @__PURE__ */ _jsxC(Slot, null, 3, "Ig_0")
    }, 0, "Ig_1");
  if (props._useCheckListContext)
    return /* @__PURE__ */ _jsxC(ChecklistTwoStateCheckbox, {
      ...props,
      children: /* @__PURE__ */ _jsxC(Slot, null, 3, "Ig_2")
    }, 0, "Ig_3");
  return /* @__PURE__ */ _jsxC(TwoStateCheckbox, {
    ...props,
    children: /* @__PURE__ */ _jsxC(Slot, null, 3, "Ig_4")
  }, 0, "Ig_5");
}, "CheckboxRoot_component_yx1fJemAdfQ"));
function getAriaChecked(triBool) {
  if (triBool === "indeterminate")
    return "mixed";
  return `${triBool === true}`;
}
const TwoStateCheckbox = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  const defaultSig = useSignal(false);
  const appliedSig = props["bind:checked"] ?? defaultSig;
  const checklistID = useSignal(props.id);
  useContextProvider(CheckboxContext, appliedSig);
  return /* @__PURE__ */ _jsxC(TwoStateCheckboxBehavior, {
    "bind:checked": appliedSig,
    tabIndex: 0,
    role: "checkbox",
    "aria-checked": getAriaChecked(appliedSig.value),
    ...props,
    get id() {
      return checklistID.value;
    },
    children: /* @__PURE__ */ _jsxC(Slot, null, 3, "Ig_6"),
    [_IMMUTABLE]: {
      tabIndex: _IMMUTABLE,
      role: _IMMUTABLE,
      id: _fnSignal((p0) => p0.value, [
        checklistID
      ], "p0.value")
    }
  }, 0, "Ig_7");
}, "TwoStateCheckbox_component_0Rhy9xIfAFg"));
const ChecklistTwoStateCheckbox = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  const checklistContext = useContext(CheckListContext);
  const defaultSig = useSignal(false);
  const appliedSig = props["bind:checked"] ?? defaultSig;
  const checklistID = useSignal(props.id);
  const syncToChecklist = useSignal(props._overWriteCheckbox);
  useContextProvider(CheckboxContext, appliedSig);
  useTaskQrl(/* @__PURE__ */ inlinedQrl(({ track }) => {
    const [appliedSig2, checklistContext2, checklistID2, syncToChecklist2] = useLexicalScope();
    if (syncToChecklist2.value !== void 0) {
      appliedSig2.value = syncToChecklist2.value;
      syncToChecklist2.value = void 0;
    }
    track(() => {
      appliedSig2.value;
    });
    if (!checklistContext2.checkboxes.value.some((e) => e === appliedSig2)) {
      const currIndex = checklistContext2.checkboxes.value.length;
      if (checklistID2.value === void 0)
        checklistID2.value = checklistContext2.idArr[currIndex];
      else
        checklistContext2.idArr[currIndex] = checklistID2.value;
      checklistContext2.checkboxes.value = [
        ...checklistContext2.checkboxes.value,
        appliedSig2
      ];
    }
    const boolArr = checklistContext2?.checkboxes.value.map((e) => e.value);
    const newVal = getTriBool(boolArr);
    checklistContext2.checklistSig.value = newVal;
  }, "ChecklistTwoStateCheckbox_component_useTask_GR2HzcxOifc", [
    appliedSig,
    checklistContext,
    checklistID,
    syncToChecklist
  ]));
  return /* @__PURE__ */ _jsxC(TwoStateCheckboxBehavior, {
    ...props,
    tabIndex: 0,
    role: "checkbox",
    "aria-checked": getAriaChecked(appliedSig.value),
    get id() {
      return checklistID.value;
    },
    "bind:checked": appliedSig,
    children: /* @__PURE__ */ _jsxC(Slot, null, 3, "Ig_8"),
    [_IMMUTABLE]: {
      tabIndex: _IMMUTABLE,
      role: _IMMUTABLE,
      id: _fnSignal((p0) => p0.value, [
        checklistID
      ], "p0.value")
    }
  }, 0, "Ig_9");
}, "ChecklistTwoStateCheckbox_component_iL66jdZi2wo"));
const MixedStateCheckbox = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  console.log("mixed");
  const checklistContext = useContext(CheckListContext);
  const appliedSig = props["bind:checked"] ?? checklistContext.checklistSig;
  const ariaControlsStrg = checklistContext.idArr.length === 0 ? "" : checklistContext.idArr.reduce((p, c) => p + " " + c);
  useContextProvider(CheckboxContext, appliedSig);
  if (props["bind:checked"] !== void 0)
    checklistContext.checklistSig = props["bind:checked"];
  const changeChecklistSig = /* @__PURE__ */ inlinedQrl(() => {
    const [appliedSig2, checklistContext2] = useLexicalScope();
    if (appliedSig2.value !== true) {
      appliedSig2.value = true;
      checklistContext2.checkboxes.value.forEach((sig) => sig.value = true);
      return;
    }
    appliedSig2.value = false;
    checklistContext2.checkboxes.value.forEach((sig) => sig.value = false);
  }, "MixedStateCheckbox_component_changeChecklistSig_8pdtvHoDU6k", [
    appliedSig,
    checklistContext
  ]);
  const handleKeyDownSync$ = _qrlSync((e) => {
    if (e.key === " ")
      e.preventDefault();
  }, 'e=>{if(e.key===" "){e.preventDefault();}}');
  const handleKeyDown$ = /* @__PURE__ */ inlinedQrl((e) => {
    const [changeChecklistSig2] = useLexicalScope();
    if (e.key === " ")
      changeChecklistSig2();
  }, "MixedStateCheckbox_component_handleKeyDown_HBtL5db3yEI", [
    changeChecklistSig
  ]);
  const handleClick$ = /* @__PURE__ */ inlinedQrl(() => {
    const [changeChecklistSig2] = useLexicalScope();
    changeChecklistSig2();
  }, "MixedStateCheckbox_component_handleClick_LeGdPnb50do", [
    changeChecklistSig
  ]);
  return /* @__PURE__ */ _jsxS("div", {
    tabIndex: 0,
    role: "checkbox",
    "aria-checked": getAriaChecked(appliedSig.value),
    "aria-controls": ariaControlsStrg,
    ...props,
    children: /* @__PURE__ */ _jsxC(Slot, null, 3, "Ig_10"),
    onKeyDown$: [
      handleKeyDownSync$,
      handleKeyDown$
    ],
    onClick$: [
      handleClick$
    ]
  }, {
    tabIndex: _IMMUTABLE,
    role: _IMMUTABLE
  }, 0, "Ig_11");
}, "MixedStateCheckbox_component_9FMLX8Pi2GI"));
const TwoStateCheckboxBehavior = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  const handleKeyDownSync$ = _qrlSync((e) => {
    if (e.key === " ")
      e.preventDefault();
  }, 'e=>{if(e.key===" "){e.preventDefault();}}');
  const handleClick = /* @__PURE__ */ inlinedQrl(() => {
    const [props2] = useLexicalScope();
    props2["bind:checked"].value = !props2["bind:checked"].value;
  }, "TwoStateCheckboxBehavior_component_handleClick_49Mj5Z1UzPE", [
    props
  ]);
  const handleKeyDown$ = /* @__PURE__ */ inlinedQrl((e) => {
    const [props2] = useLexicalScope();
    if (e.key === " ")
      props2["bind:checked"].value = !props2["bind:checked"].value;
  }, "TwoStateCheckboxBehavior_component_handleKeyDown_0xGkSGdrYCc", [
    props
  ]);
  return /* @__PURE__ */ _jsxS("div", {
    tabIndex: 0,
    role: "checkbox",
    "aria-checked": getAriaChecked(props["bind:checked"].value),
    ...props,
    children: /* @__PURE__ */ _jsxC(Slot, null, 3, "Ig_12"),
    onKeyDown$: [
      handleKeyDownSync$,
      handleKeyDown$
    ],
    onClick$: handleClick
  }, {
    tabIndex: _IMMUTABLE,
    role: _IMMUTABLE
  }, 0, "Ig_13");
}, "TwoStateCheckboxBehavior_component_17iczumCBjs"));
export {
  CheckboxRoot,
  ChecklistTwoStateCheckbox,
  MixedStateCheckbox,
  TwoStateCheckbox,
  TwoStateCheckboxBehavior as _auto_TwoStateCheckboxBehavior,
  getAriaChecked as _auto_getAriaChecked
};
